var map = {
	"./ban-white.svg": "4241",
	"./big-wrench.svg": "fc05",
	"./chart.svg": "2f02",
	"./check-circle.svg": "cfcb",
	"./chevron-black.png": "c45d",
	"./chevron-white.png": "f1aa",
	"./constructor-black.png": "b8b3",
	"./constructor-white.svg": "c167",
	"./constructor.svg": "6fa9",
	"./double-arrow.svg": "4f3a",
	"./edit-pencil.svg": "718d",
	"./filter.svg": "2376",
	"./folder.svg": "383d",
	"./home.png": "297d",
	"./home.svg": "ac9d",
	"./logout.png": "9678",
	"./lupa-contract.svg": "bd53",
	"./lupa.svg": "fe80",
	"./paper.svg": "5fef",
	"./small-wrench.svg": "c400",
	"./stats.png": "21fe",
	"./thick.svg": "a40f",
	"./upload-arrow.svg": "3d57",
	"./upload-folder.svg": "61dc",
	"./user-small.svg": "715a",
	"./user.png": "3e52",
	"./user.svg": "6aed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";